import React, { useState, useEffect } from "react";
import assets from "../../../assets/assets";
import axios from "axios";
import { useNavigate, useSearchParams } from "react-router-dom";
import { distributionUrl } from "../../Config/url";
import { IconController } from "../../Scripts/ImgController";
import Ripples from "react-ripples";
import { useCookies } from "react-cookie";

const ModalLogin = ({ setPopup, setPopupType, setPopupMessage }) => {
  const navigate = useNavigate();
  let formData = new FormData();
  const re = /\S+@\S+\.\S+/;

  useEffect(() => {
    document.title = "MMusic - Нэвтрэх";
  }, []);

  const [passwordReveal, setPasswordReveal] = useState("password");
  const [emailValue, setEmailValue] = useState("");
  const [passwordValue, setPasswordValue] = useState("");
  const [emailValid, setEmailValid] = useState(false);
  const [passwordValid, setPasswordValid] = useState(false);
  const [searchParams] = useSearchParams();
  const expiresHour = searchParams.get("expires_hour");
  const [loginButtonClickable, setLoginButtonClickable] = useState(true);
  const [cookie, setCookie, removeCookie] = useCookies();

  const passwordRevealHandler = () => {
    setPasswordReveal(passwordReveal === "password" ? "text" : "password");
  };

  useEffect(() => {
    setEmailValid(re.test(emailValue));
  }, [emailValue]);

  useEffect(() => {
    setPasswordValid(passwordValue.length >= 6);
  }, [passwordValue]);

  const loginHandler = async () => {
    if (emailValid && passwordValid) {
      if (loginButtonClickable) {
        setLoginButtonClickable(false);
        formData.append("email", emailValue);
        formData.append("password", passwordValue);

        try {
          const res = await axios.post(
            distributionUrl + "panel-oauth/guest/login",
            formData
          );

          if (res.status === 200) {
            setCookie("mmusic_token", res.data.access_token, {
              expires: expiresHour,
            });
            setCookie("who_am_i", "publisher", { expires: expiresHour });
            // setPopupType("Success");
            // setPopupMessage("loginSuccess");
            // setPopup(true);
            navigate("/");
          }
        } catch (err) {
          setLoginButtonClickable(true);
          if (err?.response?.status === 422) {
            setPopupType("Warning");
            setPopupMessage("loginFailed");
            setPopup(true);
          }
        }
      }
    } else {
      setPopupType("Warning");
      setPopupMessage("loginFailed");
      setPopup(true);
    }
  };

  return (
    <div
      className="flex flex-col"
      onKeyDown={(e) => {
        if (e.key === "Enter") {
          loginHandler();
        }
      }}
    >
      <h5 className="font-semibold text-2xl pb-8 w-full text-center">
        Нэвтрэх
      </h5>
      <h5 className="text-base pb-3">Нэр</h5>
      <input
        type="email"
        placeholder="Нэр оруулах"
        onChange={(value) => {
          setEmailValue(value.target.value);
        }}
      />
      <div className="flex flex-row justify-between w-full pt-6 pb-3">
        <h5 className="text-base">Нууц үг</h5>
        <Ripples color="#00000040" during={600} className="px-1">
          <h5
            className="text-base color-CK font-medium cursor-pointer"
            onClick={() => {
              navigate("/login/forgot");
            }}
          >
            Мартсан ?
          </h5>
        </Ripples>
      </div>
      <div className="password-input pb-8">
        <input
          type={passwordReveal}
          placeholder="Нууц үг оруулах"
          onChange={(value) => {
            setPasswordValue(value.target.value);
          }}
        />
        <div
          onClick={() => {
            passwordRevealHandler();
          }}
        >
          <IconController
            src={
              passwordReveal === "password"
                ? assets.svg.passwordEye
                : assets.svg.passwordEyeOff
            }
            className="password-eye cursor-pointer"
          />
        </div>
      </div>

      <Ripples color="#ffffff40" during={600} className="rounded-lg">
        <div
          className={`button ${
            loginButtonClickable ? "cursor-pointer" : "cursor-wait"
          }`}
          onClick={() => {
            loginHandler();
          }}
        >
          <h5
            className={`py-4 font-semibold text-base text-white ${
              loginButtonClickable ? "" : "opacity-50"
            }`}
          >
            Нэвтрэх
          </h5>
        </div>
      </Ripples>
    </div>
  );
};

export default ModalLogin;
